import {Component, OnInit, ViewChild} from '@angular/core';
import {BaseComponent} from "../../shared/base.component";
import {MatSort} from "@angular/material/sort";
import {MatPaginator} from "@angular/material/paginator";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {FormDialogService} from "../../services/form-dialog.service";
import {first, takeUntil, tap} from "rxjs/operators";
import {LockPolicyTableService} from "./lock-policy-table.service";
import {LockPolicy} from '../../_models/lock-policy';
import {HeaderDataService} from "../../services/header_data.service";
import cronstrue from 'cronstrue';
import {UtilsBarComponent} from "../utils-bar/utils.bar.component";
import {COMMON_TABLE_IMPORTS} from "../../shared/import-groups/Common";
import {RemoveUnderscorePipe, UpperFirstPipe} from "../../shared/pipes";
import {CommonModule} from "@angular/common";

@Component({
    selector: 'lock-policy-table',
    templateUrl: './lock-policy-table.component.html',
    imports: [
        UtilsBarComponent,
        COMMON_TABLE_IMPORTS,
        CommonModule,
        UpperFirstPipe,
        RemoveUnderscorePipe,
    ],
    providers: [LockPolicyTableService]
})
export class LockPolicyTableComponent extends BaseComponent implements OnInit {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    applyFilter = this.lockPolicyTableService.applyFilter;
    dataSource: LockPolicy[];
    columns = ['edit', 'name', 'enabled', 'schedule', 'last_run_on', 'created_on', 'changed_on'];
    filter_string = '';

    constructor(public lockPolicyTableService: LockPolicyTableService,
                private headerData: HeaderDataService,
                private formDialogService: FormDialogService) {
        super();
        this.lockPolicyTableService.lockPolicyDataSubject.pipe(
            tap(ds => {
                this.dataSource = ds.policies;
            }),
            takeUntil(this.onDestroy)
        ).subscribe();
    }

    ngOnInit(): void {
        this.setButtons();
        setTimeout(() => {
            this.lockPolicyTableService.sort = this.sort;
            this.lockPolicyTableService.paginator = this.paginator;
            this.lockPolicyTableService.initialise();
        });
    }

    updateSort(event) {
        this.lockPolicyTableService.updateSort(this.sort);
    }

    openDialog(policy: LockPolicy): void {
        const dialogRef: MatDialogRef<any> =
            this.formDialogService.openLockPolicyFormDialog(policy ? [policy.id] : null);
        dialogRef.afterClosed().pipe(first()).subscribe(() => this.lockPolicyTableService.refreshData());
    }

    setButtons(): void {
        this.headerData.buttons = [
            {name: 'Add Lock Policy', func: this.openDialog.bind(this), class: 'icon-plus'},
            {name: 'Refresh Table', func: this.lockPolicyTableService.refreshData.bind(this), class: 'icon-refresh'}
        ];
    }

    getScheduleDescription(policy: LockPolicy): string {
        const schedule = policy.attributes.schedule;
        if (!schedule) {
            return "Never";
        }

        try {
            // Use cronstrue to convert cron expression to human-readable string
            return cronstrue.toString(schedule, {
                use24HourTimeFormat: false,
                dayOfWeekStartIndexZero: true,
                verbose: true

            });
        } catch (error) {
            // If parsing fails, return the raw cron expression
            return schedule;
        }
    }
}
